import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { HeroImage } from "../../../atoms/HeroImage";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import CardInfo from "./CardInfo";
import { isExternalStory } from "../../../utils/story";

import "./story-card.m.css";

export const StoryCard = ({
  story,
  showTimeStamp,
  showReadTime,
  showSubheadline = false,
  isHeroStory = false,
  sectionSlug,
  isMobile = false,
}) => {
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  const iconSizes = isMobile ? { height: 64, width: 64 } : { height: 48, width: 48 };
  return isHeroStory ? (
    <div>
      <Link href={href} target={target}>
        <div styleName="hero-card">
          <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={iconSizes} />
          <CardInfo story={story} isHeroStory={isHeroStory} showSubheadline={true} sectionSlug={sectionSlug} />
          <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />
        </div>
      </Link>
    </div>
  ) : (
    <div>
      <Link href={href} target={target}>
        <div styleName="card">
          <div styleName="card-details">
            <CardInfo
              story={story}
              isHeroStory={isHeroStory}
              showSubheadline={showSubheadline}
              sectionSlug={sectionSlug}
            />
            <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />
          </div>
          <div>
            <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={{ height: 24, width: 24 }} />
          </div>
        </div>
      </Link>
    </div>
  );
};

StoryCard.propTypes = {
  story: PropTypes.shape({
    slug: PropTypes.string,
  }),
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  showSubheadline: PropTypes.bool,
  isHeroStory: PropTypes.bool,
  showImageThumbnail: PropTypes.bool,
  sectionSlug: PropTypes.string,
};
